import { Injectable } from '@angular/core';
import { CHttp } from '../../core/services/chttp.service';
import { Observable } from 'rxjs/Observable';
import { Sponsor, ModifySponsorRequest, SponsorInfo } from '../sponsors.interfaces';
import { config } from '../../app.config';

@Injectable()
export class SponsorsService {
  constructor(private http: CHttp) {}

  getAll(): Observable<SponsorInfo[]> {
    return this.http.get(`${config.api_url}sponsors`).map(resp => resp.json());
  }

  getById(id: string): Observable<Sponsor> {
    return this.http.get(`${config.api_url}sponsors/${id}`).map(resp => resp.json());
  }

  create(request: ModifySponsorRequest): Observable<Sponsor> {
    return this.http.post(`${config.api_url}sponsors`, request).map(resp => resp.json());
  }

  update(id: string, request: ModifySponsorRequest): Observable<void> {
    return this.http.put(`${config.api_url}sponsors/${id}`, request).map(resp => resp.json());
  }

  delete(id: string): Observable<void> {
    return this.http.delete(`${config.api_url}sponsors/${id}`).map(resp => resp.json());
  }
}



// WEBPACK FOOTER //
// /Users/thxgg/Projects/Work/code-hospitality-cms/src/app/sponsors/services/sponsors.service.ts